import { z } from 'zod';
/**
 * Keys that let a program act for an organisation.
 *
 * The key itself appears in exactly one response — the one that creates it —
 * and nowhere else, because only its fingerprint is stored. That is not a
 * limitation to apologise for: it is what makes the row harmless to read.
 *
 * A key acts as a member. It can do everything the product is for and cannot
 * change the team, the settings, or the domains mail leaves from, so a leaked
 * key is a nuisance rather than an organisation takeover.
 */
export const apiKeySchema = z.object({
    id: z.string(),
    label: z.string(),
    /** The visible half of the key. Identifies the row, opens nothing. */
    prefix: z.string(),
    /** Null until it is used. Distinct from used-and-not-recorded. */
    lastUsedAt: z.iso.datetime().nullable(),
    /** Null while live. A revoked key is kept, so "was this ever live" has an answer. */
    revokedAt: z.iso.datetime().nullable(),
    createdAt: z.iso.datetime(),
});
export const apiKeyListSchema = z.object({ keys: z.array(apiKeySchema) });
export const createApiKeyRequestSchema = z.object({
    /**
     * Required, and required for a reason: a list of unlabelled keys is a list
     * nobody dares revoke anything from, which means nobody ever does.
     */
    label: z.string().trim().min(1, 'give the key a name so you know what it is for').max(80),
});
export const createdApiKeySchema = z.object({
    key: apiKeySchema,
    /** Shown once. Nothing stored can reproduce it. */
    secret: z.string(),
});
//# sourceMappingURL=apiKeys.js.map